import { render, staticRenderFns } from "./UploadIdentificationDocuments.vue?vue&type=template&id=e2b0bd70&scoped=true&"
import script from "./UploadIdentificationDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadIdentificationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadIdentificationDocuments.vue?vue&type=style&index=0&id=e2b0bd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b0bd70",
  null
  
)

export default component.exports